import React from "react";
import {Badge, Container, ListGroup} from "react-bootstrap";
import './submission.css';
import Proconf from "../../components/Proconf/Proconf";
import config from "../../config";
import {dateData} from "../../components/data/data";
import {Link} from "react-router-dom";


const Submission = () => {

    return (
        <Container>

            <div className="row">
                <div className="col-md-9 text_format">
                    <h2 className="pt-4 title">IMPORTANT DATES</h2>
                    {/*<p className="d-flex justify-content-center align-items-center text-success fw-bold" >To Be Announced (TBA)</p>*/}

                    <ListGroup as="ul" variant="flush">
                        {dateData.map((item) => (
                            <div key={Math.random()}>

                                <ListGroup.Item as="li" key={Math.random()}
                                                className="d-flex justify-content-between align-items-start"
                                                data-aos="fade-up">

                                    <div className="ms-2 me-auto">
                                        <div className="fw-bold">{item.heading}</div>
                                    </div>
                                    <div className="d-flex flex-column align-items-end">
                                        <Badge bg={item.color}
                                               className={["p-2", item.status !== 'Active' ? 'text-decoration-line-through' : ''].join(' ')}
                                               pill>
                                            {item.dateEvent}
                                        </Badge>

                                        {/*{item.extension &&*/}
                                        {/*    <Badge bg={item.color}*/}
                                        {/*           className={["p-2", "mt-2", item.heading === 'Camera-Ready Submission' ? '' : 'text-decoration-line-through'].join(' ')}*/}
                                        {/*           pill>*/}
                                        {/*        {item.extension} <br/>*/}
                                        {/*        (Extended)*/}

                                        {/*    </Badge>*/}
                                        {/*}*/}

                                        {item.extension  &&
                                                <Badge bg={item.color} className={["p-2", "mt-2  item.heading==='Notification of Acceptance'?'':text-decoration-line-through"].join(' ')} pill>
                                                    {item.extension} <br/>
                                                     (Extended)

                                                </Badge>
                                            }

                                             {item.extension && item.hardexten &&(
                                                <Badge bg="success" className="p-2 mt-2" pill>
                                                    {item.hardexten} <br/>
                                                     (Hard Deadline)
                                                </Badge>)
                                            }
                                    </div>

                                </ListGroup.Item>


                            </div>
                        ))}

                    </ListGroup>
                    <h2 className="pt-4 title">Camera-Ready Paper Submission Guidelines</h2>
                    <u><h6>Step 1: Update Your Paper as per Reviewers' Comments</h6></u>
                    <ol>
                        <li><p className="mb-1">Please revise your paper according to reviewers' comments (if any).</p>
                        </li>
                        <li><p className="mb-1">Carefully check the contents of your paper to ensure that <b>similarity
                            shall be less
                            than
                            30% (Overall) and &lt; 4% from a single source</b>. Otherwise, your paper may not be
                            included in
                            IEEE Xplore Digital Library.</p>
                        </li>
                        <li><p className="mb-1">While preparing the paper, please follow the IEEE Conference <a
                            href="/template/conference-template-a4-NCIM-2025.docx" download>Microsoft
                            Word Template</a> or <a href="/template/IEEE-Conference NCIM-2025.zip"
                                                    download>LaTeX Template</a>.</p>
                        </li>
                        <li>Note that camera-ready paper should be limited to a minimum of four (4) pages and upto six
                            (6) pages, in the IEEE 2-column format including figures and references.
                        </li>

                    </ol>

                    <u><h6>Step-2: Copyright Information (at header and footer)</h6></u>

                    <ol>
                        <li><p><strong>Header:</strong> : Please add the conference title at the top-right side of the
                            first page of each paper as follows:</p>
                            <p style={{textAlign: "right"}} className="mb-0">2nd International Conference on Next-Generation Computing, IoT and Machine Learning (NCIM 2025) </p>
                            <p style={{textAlign: "right"}}>27-28 June 2025, Gazipur-1707, Bangladesh</p>
                        </li>

                        <li>
                            <p className="mb-1"><strong>Footer:</strong> Please add one IEEE Copyright Code according to
                                the following
                                conditions (generally it will be <strong> 979-8-3315-5542-9/25/$31.00 ©2025 IEEE </strong> at the footer of the 1st page only (left column) of the paper.</p>
                            <ol type="a">
                                <li>
                                    <p className="mb-1">For papers in which all authors are employed by the US
                                        government, the copyright
                                        notice is: <strong> U.S. Government work not protected by U.S.
                                            copyright</strong></p>
                                </li>
                                <li>
                                    <p className="mb-1"> For papers in which all authors are employed by a Crown
                                        government (UK, Canada,
                                        and Australia), the copyright notice is: <strong>979-8-3315-5542-9/25/$31.00 ©2025 Crown</strong></p>
                                </li>
                                <li>
                                    <p className="mb-1">For papers in which all authors are employed by the European
                                        Union, the copyright
                                        notice is: <strong> 979-8-3315-5542-9/25/$31.00 ©2025 European Union</strong></p>
                                </li>

                                <li>
                                    <p className="mb-1">For all other papers the copyright notice
                                        is:<strong> 979-8-3315-5542-9/25/$31.00 ©2025 IEEE</strong></p>
                                </li>
                            </ol>
                        </li>
                    </ol>
                    <u><h6>Step 3: Prepare IEEE Compatible PDF using IEEE PDF exPress [Site opens: 2025-05-30]</h6></u>
                    <ol>
                        <li><p className="mb-1">Go to IEEE PDF eXpress Website at <a
                            href="https://ieee-pdf-express.org">https://ieee-pdf-express.org/</a></p></li>
                        <li><p className="mb-2">First Time Users:</p>
                            <ol type="a">
                                <li><p className="mb-1">Enter Conference ID (<strong>65934X</strong>), your email
                                    address, and choose a
                                    password. Continue to enter information as prompted.</p></li>
                                <li><p className="mb-1">Check that the contact information is still valid, and click
                                    "Submit".</p></li>
                                <li><p className="mb-1">An Online confirmation will be displayed and an email
                                    confirmation will be sent
                                    verifying your account setup</p></li>
                            </ol>
                        </li>
                        <li><p className="mb-2">Previous users, but for a new conference:</p>
                            <ol type="a">
                                <li><p className="mb-1">Enter Conference ID (<strong>65934X</strong>), your email
                                    address, and enter the
                                    password you used for your account.</p></li>
                                <li><p className="mb-1">When you click "Login", you'll receive an error saying you need
                                    to set up an
                                    account. Simply click "Continue". By entering your previously used email address and
                                    password combination, you will enable your old account for access to this new
                                    conference.</p></li>
                                <li><p className="mb-1">You will receive online and email confirmation of successful
                                    account setup.</p>
                                </li>
                            </ol>
                        </li>
                        <li><p className="mb-1">For each conference paper, click "Create New Title".</p></li>
                        <li><p className="mb-1">Enter identifying text for the paper (title is recommended but not
                            required)</p></li>
                        <li><p className="mb-1">After the source file conversion, the IEEE compatible pdf will be sent
                            to your email if
                            it passes the checking process. You need to upload both the IEEE compatible pdf and proof of
                            compatibility (jpg/pdf indicating pass verdict) while uploading the camera-ready files.</p>
                        </li>
                    </ol>

                    <u><h6>Step 4: Upload the Files at CMT3 System</h6></u>
                    <ol>
                        <li><p className="mb-1">Go to <a href="https://cmt3.research.microsoft.com/NCIM2025/"
                                                         target="_blank"
                                                         rel="noopener noreferrer">
                            CMT3</a> system's conference site.</p></li>
                        <li><p className="mb-1">Click on Submit IEEE Copyright Form and follow the next steps to fill
                            the eCF. (Please
                            submit copyright form for each paper - separately. Corresponding author /
                            Responsible author/ Co-author should do it. You must inform ALL co-authors (if any) about
                            this copyright form. After filling the eCF, you should download the pdf of eCF, it's copy
                            will
                            be sent to your email too).</p></li>
                        <li><p className="mb-1">Click on camera-ready submission and submit the necessary files. You
                            need to upload
                            the final IEEE compatible pdf of your paper (Renamed
                            as <strong>PaperID_Paper.pdf</strong>), proof of similarity check file (Renamed as <strong>PaperID_similarity.pdf</strong>) proof of IEEE
                            compatibility check (Renamed as <strong>PaperID_pdfxpress.pdf</strong>), proof of eCF
                            (Renamed
                            as <strong>PaperID_eCF.pdf</strong>) update/add abstract if required (Renamed as <strong>PaperID_abstract.pdf</strong>)
                            and source file (Word or LaTeX) of your paper along with necessary information such as
                            final paper title and final abstract.</p></li>
                        <li>
                            <p className="mb-1">If your paper's source file is a word document, simply upload the
                                document. If your source file
                                is a LaTeX project, please create a zip file of the project and upload the zip file.</p>
                        </li>
                    </ol>
                    <p style={{"text-align": "justify"}}>By completing these 4 steps, you have completed the camera-ready submission. After the submission, you must check/complete the online registration process as well. To register for the conference, <Link to="/registration">Click Here</Link>.</p>

                    <h2 className="pt-4 title">Oral Presentation Preparation Guideline:</h2>
                    <p style={{"text-align": "justify"}}>
                        Prepare the presentation slides (i.e., only for oral presentations) as per the attached template <a
                        href="/template/NCIM-2025-Presentation-Template.pptx"  target="_blank">(Click Here to download)</a> and guidelines. Please Note:
                    </p>
                    <ul>
                        <li>The oral presentation should be in English with a time duration of 10 minutes, with an additional 3 minutes for Q&A.</li>
                        <li> Prepare your presentation in Power-point and save it in PDF with named as PaperID.pdf</li>
                        <li> •	Upload the presentation files to the below link as per schedule <a href="/template/ProgramSchedule2025.pdf"  target="_blank">(Click here for Program Schedule) </a> of your presentation by 25 June, 2025</li>
                        <li> Submission URL <a href="https://drive.google.com/drive/folders/16Cw0Zr8EnADjfQ4TyoL3rWG-ERQO0BXR?usp=sharing" target="_blank">https://drive.google.com/drive/folders/16Cw0Zr8EnADjfQ4TyoL3rWG-ERQO0BXR?usp=sharing</a></li>

                    </ul>








                    <h2 className="pt-4 title">Paper Submission Guidelines</h2>

                    <div className="mt-4" data-aos="fade-up" data-aos-anchor-placement="top-bottom">
                        <p style={{"text-align": "justify"}}>Authors are invited to submit their original, unpublished
                            papers electronically (PDF format using the IEEE conference template) through conference
                            website. Paper submissions should be limited to a minimum of four (4) pages and upto six (6)
                            pages, in the IEEE 2-column
                            format including figures and references. All submissions will be reviewed double-blind by
                            the
                            Program Committee on the basis of technical quality, originality, and clarity of
                            presentation.
                            <b className=""> Accepted papers will be submitted for inclusion into IEEE
                                Xplore subject to meeting IEEE Xplore’s scope and quality requirements. (Conference Id: 65934X)</b>.
                        </p>

                        <ul>
                            <li>Make sure that no part of this paper (including Figure/Table/Algorithm) is copied from
                                other
                                sources. Make sure that you did not do any plagiarism or self-plagiarism? <b>The
                                    similarity
                                    shall be less than 30% (Overall) and &lt; 4% from a single source.</b>
                            </li>
                        </ul>
                    </div>

                    <div className="mt-4  " data-aos="fade-up" data-aos-anchor-placement="top-bottom">
                        <b><p>Before submission</p></b>
                        <ul>
                            <li>Before submitting the manuscript, authors are requested to read and follow the
                                “IEEE Submission Policies” in <a
                                    href="https://conferences.ieeeauthorcenter.ieee.org/author-ethics/guidelines-and-policies/submission-policies/"
                                    target="_blank" rel="noopener noreferrer"> Click
                                    Here</a> and “IEEE Peer Review Policy” in <a
                                    href="https://conferences.ieeeauthorcenter.ieee.org/understand-peer-review/"
                                    target="_blank" rel="noopener noreferrer"> Click
                                    Here</a> .
                            </li>
                        </ul>
                    </div>

                    <div className="mt-4  " data-aos="fade-up">
                        <b><p>Double-Blind Paper:</p></b>
                        <ul>
                            <li>The authors should not include their names, affiliations, postal addresses, and email
                                addresses in the initial manuscript. If it is not maintained the manuscript will be
                                immediately rejected.
                            </li>
                        </ul>
                    </div>

                    <div className="mt-4  " data-aos="fade-up">
                        <b><p>Manuscript Template:</p></b>
                        <ul>
                            <li>Submissions must follow standard IEEE conference templates (Please download and use A4
                                Size Template). The manuscript template is provided website or can be downloaded from
                                IEEE website:

                                <a href="https://www.ieee.org/conferences/publishing/templates.html" target="_blank"
                                   rel="noopener noreferrer"> Click
                                    Here</a>
                            </li>
                        </ul>
                    </div>

                    <div className="mt-4  " data-aos="fade-up">
                        <b><p>Microsoft CMT Submission:</p></b>
                        <ul>
                            <li>Each paper needs to be submitted electronically as a single PDF file through Microsoft
                                CMT:
                                <a href="https://cmt3.research.microsoft.com/NCIM2025/" target="_blank"  rel="noopener noreferrer"> Click
                                 Here</a>
                            </li>
                        </ul>
                    </div>


                </div>
                <div className="col-md-3">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="pt-4 title">DOWNLOAD TEMPLATE </h2><ListGroup variant="flush" className="submission" data-aos="fade-up">
                        <ListGroup.Item>
                            <a href="/template/IEEE_conference_NCIM-2025-template.zip" download>Latex Template</a>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <a href="/template/IEEE_conference_NCIM-2025-template.docx" download>MSword Paper
                                Template</a>

                        </ListGroup.Item>

                        {/*<ListGroup.Item>*/}
                        {/*    <a href="/template/Copyright-Form.docx" download>Copyright Form</a>*/}

                        {/*</ListGroup.Item>*/}
                        {/*<ListGroup.Item>*/}
                        {/*    <a href="/template/Permission-Request-Form-Springer.doc" download>Permission Request*/}
                        {/*        Form</a>*/}

                        {/*</ListGroup.Item>*/}
                    </ListGroup>
                        </div>

                        <div className="col-md-12">
                            <h2 className="pt-4 title">SUBMISSION LINK </h2><ListGroup variant="flush" className="submission" data-aos="fade-up">
                        <ListGroup.Item>
                            CMT:
                                <a href="https://cmt3.research.microsoft.com/NCIM2025/" target="_blank"  rel="noopener noreferrer"> Click
                                 Here</a>
                        </ListGroup.Item>

                    </ListGroup>
                        </div>

                    </div>


                </div>

            </div>
        </Container>
    )

}

export default Submission;